import { TPrice } from '~/shared/components/ProductCard/components/Price';

/**
 * @deprecated Use `getProductSchemaPrice` from `~/services/schemas/product/salesforce` instead.
 * Kept for the card components that still read the data-contract `TPrice`; they should move
 * across with the rest of the product/price type alignment (IMC-1671).
 */
export function getSchemaPrice(prices?: TPrice[]) {
    return prices?.find((price) => price.schema);
}

/**
 * @deprecated Use `getProductNonSchemaPrice` from `~/services/schemas/product/salesforce` instead.
 * See the note on `getSchemaPrice`.
 */
export function getNonSchemaPrice(prices?: TPrice[]) {
    return prices?.find((price) => price.schema === false);
}
